import { render } from "./EmployeeIncome.vue?vue&type=template&id=46612e95"
import script from "./EmployeeIncome.vue?vue&type=script&lang=js"
export * from "./EmployeeIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__